/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateSocialUploadCompositionsDetailMutationRequest, CreateSocialUploadCompositionsDetailMutationResponse, CreateSocialUploadCompositionsDetailPathParams } from "../models/CreateSocialUploadCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createSocialUploadCompositionsDetail } from "../axios/createSocialUploadCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createSocialUploadCompositionsDetailMutationKey = () => ["web-app-bff-api", { url: '/compositions/:id/social-uploads' }] as const

export type CreateSocialUploadCompositionsDetailMutationKey = ReturnType<typeof createSocialUploadCompositionsDetailMutationKey>

export function createSocialUploadCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateSocialUploadCompositionsDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createSocialUploadCompositionsDetailMutationKey()
        return mutationOptions<CreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: CreateSocialUploadCompositionsDetailPathParams["id"], data: CreateSocialUploadCompositionsDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return createSocialUploadCompositionsDetail(id, data, config)
          },
        })

}

/**
 * @summary Start social upload for a video-editor edit (composition context)
 * {@link /compositions/:id/social-uploads}
 */
export function useCreateSocialUploadCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: CreateSocialUploadCompositionsDetailPathParams["id"], data: CreateSocialUploadCompositionsDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateSocialUploadCompositionsDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createSocialUploadCompositionsDetailMutationKey()

          const baseOptions = createSocialUploadCompositionsDetailMutationOptions(config) as UseMutationOptions<CreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: CreateSocialUploadCompositionsDetailPathParams["id"], data: CreateSocialUploadCompositionsDetailMutationRequest}, TContext>
          

          return useMutation<CreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: CreateSocialUploadCompositionsDetailPathParams["id"], data: CreateSocialUploadCompositionsDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: CreateSocialUploadCompositionsDetailPathParams["id"], data: CreateSocialUploadCompositionsDetailMutationRequest}, TContext>
      
}